import { LegacyPageUrlMappingResponseDtoResponse } from '@asset-metrix/portal-gateway-client-js';
import { QueryFunction } from '@tanstack/react-query';

import { QueryKeyWithRole } from '../../utils/prependRoleId';
import { portalGatewayClient } from '../portalGatewayClient';

export type FetchLegacyUrlMappingQueryKey = readonly [
  { legacyUrlPath: string },
];
export const fetchLegacyUrlMapping: QueryFunction<
  LegacyPageUrlMappingResponseDtoResponse,
  QueryKeyWithRole<FetchLegacyUrlMappingQueryKey>
> = async ({ queryKey }) => {
  const { legacyUrlPath } = queryKey[2];
  try {
    const response = await portalGatewayClient.navigation.getUrlMapping({
      legacyUrlPath,
    });
    return response.data;
  } catch (e: unknown) {
    console.error(e);
    throw e;
  }
};
